/**
 * 
 */
export enum Debug {
    /**
     * No debugging.
     */
    None,
    
    /**
     * Show warning level logs.
     */
    Warn,

    /**
     * Show info level logs.
     */
    Info
}